import { normalize } from "../common";
import { CONTAINER_NAME } from "../_utils/constant";
var chooseImage = normalize.chooseImage(function (args) {
  return wx.chooseImage(args);
}, CONTAINER_NAME.WECHAT);
export default chooseImage;